var _path, _path2, _path3, _path4, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncexitAdminLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.252 2.16321L5.01624 0.302734V14.1012L9.48273 13.5585L10.1899 15.3027L11.9393 13.0934L15.252 12.6671V2.16321Z",
    fill: "#F6F7FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.68123 2.04695L0.251953 1.19423V13.171L4.68123 12.4733V2.04695Z",
    fill: "#12B6BC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3814 7.31263L11.1481 7.28486L11.1485 7.28159L11.1494 7.27347L11.1494 7.26529C11.1494 7.24335 11.1483 7.22119 11.146 7.19913L11.3814 7.31263ZM10.9363 8.14031L10.9122 8.2458C10.8887 8.30998 10.8847 8.37321 10.8838 8.47245L10.8837 8.48923L10.8872 8.50563L10.9175 8.64499L10.8721 8.50121L10.8417 8.19464C10.8733 8.18066 10.9057 8.16355 10.9363 8.14031ZM11.0449 9.40309C11.045 9.40307 11.045 9.40305 11.0451 9.40303L11.0449 9.40309ZM11.6425 8.43169L11.6425 8.35979L12.1022 8.35979L12.1022 8.43169L11.6425 8.43169ZM10.9933 6.4085C10.9933 6.50851 10.9169 6.5791 10.8354 6.5791C10.7539 6.5791 10.6775 6.50851 10.6775 6.4085C10.6775 6.30849 10.7539 6.23789 10.8354 6.23789C10.9169 6.23789 10.9933 6.30849 10.9933 6.4085Z",
    fill: "white",
    stroke: "#133F7D",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94774 8.43559L9.97012 8.99887L9.72674 8.99887L9.72674 8.2688C9.73541 8.28508 9.74514 8.30065 9.75591 8.31531C9.7988 8.37371 9.86305 8.42364 9.94558 8.4347L9.94546 8.43559L9.94774 8.43559ZM9.9211 7.71709C9.82835 7.74994 9.76545 7.80721 9.72674 7.87436L9.72674 6.32627H9.72682L9.72666 6.32226C9.72309 6.23337 9.70887 6.154 9.66309 6.08437C9.61816 6.01604 9.55107 5.96974 9.47021 5.92782L8.55386 5.40273L10.0326 5.40273C10.095 5.40273 10.1524 5.45658 10.1524 5.53161L10.1524 7.60838L9.9211 7.71709ZM9.11529 7.65724C9.11529 7.6618 9.1136 7.66503 9.11175 7.66695C9.10997 7.66881 9.10871 7.66893 9.10804 7.66893C9.10736 7.66893 9.1061 7.66881 9.10432 7.66695C9.10247 7.66503 9.10078 7.6618 9.10078 7.65724C9.10078 7.65268 9.10247 7.64945 9.10432 7.64753C9.1061 7.64567 9.10736 7.64555 9.10804 7.64555C9.10871 7.64555 9.10997 7.64567 9.11175 7.64753C9.1136 7.64945 9.11529 7.65268 9.11529 7.65724Z",
    fill: "white",
    stroke: "#133F7D",
    strokeWidth: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.74695,
    y: 6.02625,
    width: 0.220597,
    height: 0.531032,
    rx: 0.110299,
    fill: "white",
    stroke: "#133F7D",
    strokeWidth: 0.01
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.74695,
    y: 8.13758,
    width: 0.220597,
    height: 0.531032,
    rx: 0.110299,
    fill: "white",
    stroke: "#133F7D",
    strokeWidth: 0.01
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncexitAdminLogo);
export default __webpack_public_path__ + "static/media/incexit-admin-logo.aa2fe4b290a4e77ff46f454cb04ba2b4.svg";
export { ForwardRef as ReactComponent };